// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 21:03:52

export default {
  "id": "master-of-3-tiles",
  "slug": "master-of-3-tiles",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/fdb5658c4298427cbb99911f713c377c-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/fdb5658c4298427cbb99911f713c377c/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Master of 3 Tiles",
      "description": "Step into a fresh take on classic Mahjong! Your mission is clear: find matching tiles, gather sets of three, and clear the board. Each level ups the challenge, sharpening your skills as you progress. Ready to conquer every board and prove your mastery? Let the tile-matching adventure begin!",
      "instructions": "1. Find tiles with similar pictures\n2. Collect three of the same tiles\n3. Clear the field completely of tiles\n4. Congratulations! The level is passed",
      "genres": [
        "Merge"
      ],
      "tags": [
        "connection",
        "logic",
        "matching",
        "tiles"
      ]
    },
    "zh-CN": {
      "title": "三砖大师",
      "description": "踏入经典麻将的全新体验！你的任务是明确的：找到匹配的牌，收集三张一组，清理牌桌。每一关都会提升挑战，随着你的进步磨练你的技巧。准备好征服每一张牌桌并证明你的精通了吗？让牌匹配冒险开始吧！",
      "instructions": "1. 找到图案相似的瓷砖\n2. 收集三个相同的瓷砖\n3. 完全清除场上的瓷砖\n4. 恭喜！关卡通过",
      "genres": [
        "合并"
      ],
      "tags": [
        "连接",
        "逻辑",
        "匹配",
        "拼图"
      ]
    },
    "zh-TW": {
      "title": "三塊Tile的大師",
      "description": "進入經典麻將的新風格！你的任務清晰：尋找匹配的磁片，組合三顆磁片，清空遊戲板。每關都增加挑戰，隨著進度提升你的技巧。準備征服每一塊遊戲板並證明你的精通？讓磁片配對冒險開始！",
      "instructions": "1. 找到圖片相似的磚塊\n2. 收集三個相同的磚塊\n3. 完全清空場地上的磚塊\n4. 恭喜！你已通過此關卡",
      "genres": [
        "合併"
      ],
      "tags": [
        "連線",
        "邏輯",
        "配對",
        "磁磚"
      ]
    },
    "zh-HK": {
      "title": "三塊棋霸主",
      "description": "步進經典麻將的全新體驗！你的任務清晰：尋找匹配的牌，組成三的倍數組合，清空桌面。每過一關挑戰度上升，隨著進步提升你的技巧。準備征服每一個桌面並證明你的精通？讓牌配對冒險開始！",
      "instructions": "1. 找尋圖片相似的圖 tile\n2. 獲得三個相同的 tile\n3. 完全清空場地上的 tile\n4. 恭喜！關卡通過",
      "genres": [
        "合拼"
      ],
      "tags": [
        "連線",
        "邏輯",
        "配對",
        "圖Tile"
      ]
    },
    "ja": {
      "title": "3タイルのマスター",
      "description": "古典麻雀の新たな挑戦に踏み込め！あなたの使命は明確です：一致するタイルを見つけ、三つのセットを集め、ボードをクリアします。各レベルで挑戦が高まり、進むにつれてスキルを鍛えます。全てのボードを征服し、マスターの技を見せつけよう！タイル一致の冒険が始まります！",
      "instructions": "1. 似た絵のタイルを見つける\n2. 同じタイルを3つ集める\n3. タイルを全てフィールドからクリアする\n4. おめでとう！レベルをクリアしました",
      "genres": [
        "合体"
      ],
      "tags": [
        "接続",
        "論理",
        "一致",
        "タイル"
      ]
    },
    "ko": {
      "title": "마스터 오브 3 타일",
      "description": "클래식 맞추기 Mahjong의 새로운 방식에 걸어 들어오세요! 여러분의 임무는 명확합니다: 일치하는 타일을 찾아 세개의 세트를 모아 게임 보드를 정리하세요. 각 레벨마다 도전이 증가하며, 진행할수록 여러분의 기술을 세련하게 해줍니다. 모든 보드를克服하고 전문가의 힘을 증명할 준비가 되셨나요? 타일 맞추기 모험을 시작해보세요!",
      "instructions": "1. 유사한 그림을 가진 타일을 찾아주세요\n2. 같은 타일을 세 개 모으세요\n3. 타일을 모두 제거하여 필드를 완전히 클리어하세요\n4. 축하합니다! 레벨을 통과했습니다",
      "genres": [
        "결합"
      ],
      "tags": [
        "연결",
        "논리",
        "매칭",
        "타일"
      ]
    },
    "fr": {
      "title": "Maître des 3 Tuiles",
      "description": "Plongez dans une nouvelle approche du classique Mahjong ! Votre mission est claire : trouvez des tuiles correspondantes, rassemblez des ensembles de trois et nettoyez le plateau. Chaque niveau augmente le défi, affûtant vos compétences au fur et à mesure de votre progression. Prêt à conquérir chaque plateau et à prouver votre maestrie ? L'aventure de correspondance de tuiles commence !",
      "instructions": "1. Trouvez des tuiles avec des images similaires\n2. Collectez trois tuiles identiques\n3. Nettoyez complètement le champ des tuiles\n4. Félicitations ! Le niveau est terminé",
      "genres": [
        "Fusionner"
      ],
      "tags": [
        "connexion",
        "logique",
        "correspondance",
        "tuiles"
      ]
    }
  }
};
